import fetch from 'isomorphic-fetch';
import BaseApi from '../../../../shared/javascripts/api/BaseApi'

class UserProgressApi extends BaseApi {
  static fetchOverallScore(userId) {
    return fetch(this.buildRequest(`/v1/google_play/progresses/summary.json?user_id=${userId}`))
  }

  static fetchWeeklyScores(userId) {
    return fetch(this.buildRequest(`/v1/google_play/progresses/weekly.json?user_id=${userId}`))
  }

  static fetchGameScores(userId) {
    return fetch(this.buildRequest(`/v1/google_play/progresses.json?user_id=${userId}`))
  }

  static fetchCategoryOverallScore(userId) {
    return fetch(this.buildRequest(`/v1/google_play/progresses/category_summary.json?user_id=${userId}`))
  }

  static fetchCategoryScores(userId) {
    return fetch(this.buildRequest(`/v1/google_play/progresses/weekly_category.json?user_id=${userId}`))
  }
}

export default UserProgressApi



// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/api/UserProgressApi.js